export default "__VITE_ASSET__TCevXy$W__"